export default __webpack_public_path__ + "static/media/10.da7ffbc4.png";